import axios from './index'

class callme{
    static activityDynamic(options) {
        return axios.get(`/nice-api-order/v1/mentionme/activityDynamic`)
    }
    static sendCode(options) {
        return axios.get(`/nice-api-order/v1/mentionme/sendCode/${options.mobile}`)
    }
    static receiveGift(options) {
        return axios.post(`/nice-api-order/v1/mentionme/receiveGift`,options)
    }
    static getNewGoods(options) {
        return axios.get(`/nice-api-order/v1/mentionme/getNewGoods`,options)
    }
    static receiveCouponList(options) {
        return axios.get(`/nice-api-order/v1/mentionme/receiveCouponList`,{params:options})
    }
    static selectInvitedAddress(options) {
        return axios.get(`/nice-api-order/v1/mentionme/selectInvitedAddress/${options.invitedCustomerId}`)
    }
    static upAddAddress(options) {
        return axios.put(`/nice-api-order/v1/mentionme/up_add_address`,options)
    }
    static getServiceCode(options){
        return axios.get(`/nice-api-order/v1/mentionme/getServiceCode`,{params:options})
    }
    static receiveGiftList(options) {
        return axios.get(`/nice-api-order/v1/mentionme/receiveGiftList/${options.customerId}`,options)
    }
    static getUserById(options) {
        return axios.get(`/nice-api-customer/v1/other/customer/${options.uid}`,options)
    }
}
export default callme;